import { NgModule, ModuleWithProviders } from '@angular/core';
import {CommonModule} from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
// import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
@NgModule({
    imports: [
        // BrowserAnimationsModule,
        CommonModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatInputModule,
        MatCheckboxModule,
        MatTableModule,
        MatDividerModule,
        MatListModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatSelectModule,
        // MatSnackBarModule,
        MatIconModule,
        MatDialogModule,
        MatPaginatorModule,
        MatSortModule
    ],
  exports: [
    // BrowserAnimationsModule,
      MatProgressSpinnerModule,
      MatTabsModule,
      MatInputModule,
      MatCheckboxModule,
      MatTableModule,
      MatDividerModule,
      MatListModule,
      MatSlideToggleModule,
      MatTooltipModule,
      MatSelectModule,
      // MatSnackBarModule,
      MatIconModule,
      MatDialogModule,
      MatPaginatorModule,
      MatSortModule
    ]
})
export class MaterialSharedModuleAll {
  static forRoot(): ModuleWithProviders<MaterialSharedModuleAll> {
    return {
      ngModule: MaterialSharedModuleAll,
      providers: [MatIconRegistry]
    };
  }
}